import React from "react";
import '../../styles/common/decrement-increment-buttons.scss';
import {FontIcon} from "./FontIcon";


interface IDecrementIncrementButtonsProps{
  onIncrementClick: ()=> void;
  onDecrementClick: ()=> void;
  subLabel?: string;
  label: string;
  decrementButtonEnabled: boolean;
  incrementButtonEnabled: boolean;
  disabled?: boolean;
}
export default function DecrementIncrementButtons({
  onIncrementClick,
  onDecrementClick,
  subLabel,
  label,
  decrementButtonEnabled,
  incrementButtonEnabled,
  disabled
}: IDecrementIncrementButtonsProps) {
  const subLabelElement = createSubLabelElement(subLabel);
  const decrementDisabledClassName = decrementButtonEnabled ? "" : "disabled";
  const incrementDisabledClassName = incrementButtonEnabled ? "" : "disabled";
  const disabledClassName = disabled ? `disabled` : ``;
  return (
    <div className={`decrement-increment-buttons ${disabledClassName}`}>
      <div className="label">{label}</div>
      {subLabelElement}
      <div className="buttons">
        <button className={`decrement-button ${decrementDisabledClassName}`} onClick={()=> {if(decrementButtonEnabled && !disabled) onDecrementClick()} }>
          <FontIcon icon={"icon-minus"}/>
        </button>
        <button className={`increment-button ${incrementDisabledClassName}`} onClick={()=> {if(incrementButtonEnabled && !disabled) onIncrementClick()}}>
          <FontIcon icon={"icon-plus"}/>
        </button>
      </div>
    </div>
  );
}

function createSubLabelElement(subLabel: string | undefined){
  if(!subLabel){ return null; }
  return <div className="sub-label">{subLabel}</div>
}
